import axios from 'axios';
import qs from 'qs';

export const createLessonCategory = (data: any) =>
  axios.post('/api/v1/lesson-categories', data);

export const updateLessonCategoryById = ({
  categoryId,
  data,
}: {
  categoryId: string;
  data: any;
}) => axios.put(`/api/v1/lesson-categories/${categoryId}`, data);

export const getLessonCategories = (params: Record<string, any>) =>
  axios.get(`/api/v1/lesson-categories?${qs.stringify(params)}`);

export const getLessonCategoryById = (categoryId: string) =>
  axios.get(`/api/v1/lesson-categories/${categoryId}`);

export const removeLessonCategoryById = (categoryId: string) =>
  axios.delete(`/api/v1/lesson-categories/${categoryId}`);
